import { format, parseISO } from 'date-fns';

export function formatINR(value) {
    const num = Number(value || 0);
    return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 2 }).format(num);
}

export function formatNumber(value) {
    return new Intl.NumberFormat('en-IN').format(Number(value || 0));
}

export function formatDateTime(iso) {
    if (!iso) return '-';
    try {
        return format(parseISO(iso), 'dd MMM yyyy, hh:mm a');
    } catch {
        return iso;
    }
}

export function formatDate(iso) {
    if (!iso) return '-';
    try {
        return format(parseISO(iso), 'dd MMM yyyy');
    } catch {
        return iso;
    }
}

export const PLATFORM_ACCENTS = {
    olaparty: { color: '#FF7A59', bg: '#FFF1EC', border: '#FFD2C6' },
    trumeet: { color: '#2BB3A6', bg: '#E9FBF8', border: '#BFF1EA' },
};

export function statusBadgeClass(status) {
    const s = (status || '').toLowerCase();
    if (s === 'completed' || s === 'success' || s === 'paid' || s === 'approved' || s === 'connected') return 'bg-emerald-50 text-emerald-700 border-emerald-200';
    if (s === 'pending' || s === 'processing' || s === 'pending_manual' || s.includes('pending')) return 'bg-amber-50 text-amber-800 border-amber-200';
    if (s === 'failed' || s === 'rejected' || s === 'invalid' || s === 'error' || s === 'paid_bridge_failed') return 'bg-rose-50 text-rose-700 border-rose-200';
    if (s === 'created' || s === 'not_configured') return 'bg-slate-100 text-slate-700 border-slate-200';
    return 'bg-slate-100 text-slate-700 border-slate-200';
}
